"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
let HostedFile = class HostedFile extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.screenshotIncludedHtml = '';
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: false,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], HostedFile.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], HostedFile.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "url", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "filename", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "originalFilename", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "encoding", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "mimetype", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "isPublic", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "isScreenshot", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "screenshotInProgress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "screenshotSucceeded", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "screenshotFailed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "uploadToHostInProgress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "uploadToHostSucceeded", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "uploadToHostFailed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "screenshotHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "screenshotOverlayHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "screenshotIncludedHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], HostedFile.prototype, "screenshotHeadHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], HostedFile.prototype, "screenshotIsPartial", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 500, type: 'integer' }),
    tslib_1.__metadata("design:type", Number)
], HostedFile.prototype, "screenshotRenderTimeout", void 0);
HostedFile = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], HostedFile);
exports.HostedFile = HostedFile;
class HostedFileEntity extends HostedFile {
    constructor() {
        super(...arguments);
        this.toString = () => {
            return this.filename || this.originalFilename || this.isScreenshot
                ? 'unnamed screenshot'
                : 'unnamed file';
        };
    }
}
exports.HostedFileEntity = HostedFileEntity;
//# sourceMappingURL=HostedFile.js.map